<template>
    <div id="stepcontent">

        <div id="title">
            <h2>Património</h2>
            <p>Preencha com os dados patrimoniais</p>
        </div>

        <div id="formblock">

            <div>

                <div class="sectiontitle" style="margin-top: 1rem;">
                    <hr><h3> Dados Patrimoniais dos Proponentes</h3><hr>
                </div>

                <div v-for="(p, index) in stepdata.patrimonios" style="margin-bottom:3.5rem">
                    <div class="columns" style="padding: 0 0.75rem;">
                        <div class="column is-3">
                            <div class="input-line cursor-pointer" @click="ddopen !== 'imovel'+index ? ddopen = 'imovel'+index: ddopen = null">
                                <div class="input-title" v-if="!p.imovel">
                                    <p>Imóvel</p>
                                </div>

                                <div class="input-field">
                                    <input :value="p.imovel" disabled type="text">
                                </div>

                                <div  class="input-icon">
                                    <img :class="{'flip': ddopen === 'imovel'+index, 'unflip': ddopen !== 'imovel'+index}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                                </div>
                            </div>
                            <transition name="slide-fade">
                                <div v-if="ddopen === 'imovel'+index" class="input-expanded" style="width:23.66%;">
                                    <p v-for="i in imoveis" class="expanded-line" @click="p.imovel = i; ddopen = null;">{{i}}</p>
                                </div>
                            </transition>
                        </div>

                        <div class="column is-4">
                            <div class="input-line">
                                <div class="input-title" v-if="!p.valor">
                                    <p>Valor</p>
                                </div>

                                <div class="input-field">
                                    <money v-model="p.valor" v-bind="money" ></money>
                                </div>

                                <div class="input-icon">
                                    €
                                </div>
                            </div>
                        </div>


                        <div class="column is-5">
                            <div class="input-line cursor-pointer" @click="ddopen !== 'utilizacao'+index ? ddopen = 'utilizacao'+index: ddopen = null">
                                <div class="input-title" v-if="!p.utilizacao">
                                    <p>Utilização</p>
                                </div>

                                <div class="input-field">
                                    <input :value="p.utilizacao" disabled type="text">
                                </div>

                                <div  class="input-icon">
                                    <img  :class="{'flip': ddopen === 'utilizacao'+index, 'unflip': ddopen !== 'utilizacao'+index}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                                </div>
                            </div>
                            <transition name="slide-fade">
                                <div v-if="ddopen === 'utilizacao'+index" class="input-expanded" style="width:23.66%;">
                                    <p v-for="i in utilizacao" class="expanded-line" @click="p.utilizacao = i; ddopen = null;">{{i}}</p>
                                </div>
                            </transition>
                        </div>



                    </div>

                    <div class="input-line cursor-pointer" @click="ddopen !== 'vende'+index ? ddopen = 'vende'+index: ddopen = null" style="margin-top:-0.5rem;">
                        <div class="input-title">
                            <p>Vende para comprar?</p>
                        </div>

                        <div class="input-field">
                            <input :value="p.vende" disabled type="text">
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'vende'+index, 'unflip': ddopen !== 'vende'+index}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'vende'+index" class="input-expanded">
                            <p v-for="i in vende" class="expanded-line" @click="p.vende = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>

                </div>

                <div class="columns" style="padding: 0 0.75rem;">
                    <div class="column is-3">
                        <div :class="{'badinput': bad(stepdata.patrimonio.imovel)}" class="input-line cursor-pointer" @click="ddopen !== 'imovelx' ? ddopen = 'imovelx': ddopen = null">
                            <div class="input-title" v-if="!stepdata.patrimonio.imovel">
                                <p>Imóvel</p>
                            </div>

                            <div class="input-field">
                                <input :value="stepdata.patrimonio.imovel" disabled type="text">
                            </div>

                            <div  class="input-icon">
                                <img :class="{'flip': ddopen === 'imovelx', 'unflip': ddopen !== 'imovelx'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                            </div>
                        </div>
                        <transition name="slide-fade">
                            <div v-if="ddopen === 'imovelx'" class="input-expanded" style="width:23.66%;">
                                <p v-for="i in imoveis" class="expanded-line" @click="stepdata.patrimonio.imovel = i; ddopen = null;">{{i}}</p>
                            </div>
                        </transition>
                    </div>

                    <div class="column is-4">
                        <div :class="{'badinput': bad(stepdata.patrimonio.valor)}" class="input-line">
                            <div  class="input-title" v-if="!stepdata.patrimonio.valor">
                                <p>Valor</p>
                            </div>

                            <div class="input-field">
                                <money v-model="stepdata.patrimonio.valor" v-bind="money" ></money>
                            </div>

                            <div class="input-icon">
                                €
                            </div>
                        </div>
                    </div>


                    <div class="column is-5">
                        <div :class="{'badinput': bad(stepdata.patrimonio.utilizacao)}" @click="ddopen !== 'utilizacaox' ? ddopen = 'utilizacaox': ddopen = null" class="input-line cursor-pointer">
                            <div class="input-title" v-if="!stepdata.patrimonio.utilizacao">
                                <p>Utilização</p>
                            </div>

                            <div class="input-field">
                                <input :value="stepdata.patrimonio.utilizacao" disabled type="text">
                            </div>

                            <div  class="input-icon">
                                <img  :class="{'flip': ddopen === 'utilizacaox', 'unflip': ddopen !== 'utilizacaox'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                            </div>
                        </div>
                        <transition name="slide-fade">
                            <div v-if="ddopen === 'utilizacaox'" class="input-expanded" style="width:23.66%;">
                                <p v-for="i in utilizacao" class="expanded-line" @click="stepdata.patrimonio.utilizacao = i; ddopen = null;">{{i}}</p>
                            </div>
                        </transition>
                    </div>

                </div>

                <div :class="{'badinput': bad(stepdata.patrimonio.vende)}"  @click="ddopen !== 'vendex' ? ddopen = 'vendex': ddopen = null" class="input-line cursor-pointer" style="margin-top:-0.5rem;">
                    <div class="input-title">
                        <p>Vende para comprar?</p>
                    </div>

                    <div class="input-field">
                        <input :value="stepdata.patrimonio.vende" disabled type="text">
                    </div>

                    <div  class="input-icon">
                        <img :class="{'flip': ddopen === 'vendex', 'unflip': ddopen !== 'vendex'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                    </div>
                </div>

                <transition name="slide-fade">
                    <div v-if="ddopen === 'vendex'" class="input-expanded">
                        <p v-for="i in vende" class="expanded-line" @click="stepdata.patrimonio.vende = i; ddopen = null;">{{i}}</p>
                    </div>
                </transition>

            </div>

            <div class="cursor-pointer" style="padding:3rem; cursor:pointer;" @click="addImovel">
                <p>
                    <img src="/static/images/pedido-ch/add-circular-button.svg" alt="" style="width:1rem;height:1rem; margin-right:1rem; vertical-align:middle;">
                    Acrescentar mais imóveis
                </p>
            </div>

        </div>

    </div>

</template>
<script>
import { Money } from "v-money";
import { mask } from "vue-the-mask";
export default {
  components: {
    Money
  },

  directives: {
    mask
  },

  props: ["stepdata", "steps"],

  data() {
    return {
      imoveis: [
        "Urbano",
        "Rústico",
        "Terreno",
        "Garagem",
        "Loja",
        "Armazém",
        "Industrial"
      ],
      utilizacao: [
        "Residência Principal",
        "Residência Secundária",
        "Aluguer",
        "Uso Profissional"
      ],
      vende: ["Sim", "Não"],

      tryAdd: false,

      ddopen: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false
      }
    };
  },

  computed: {
    missingField() {
      return (
        /*!this.stepdata.patrimonio.imovel ||
        !this.stepdata.patrimonio.valor ||
        !this.stepdata.patrimonio.utilizacao ||
        !this.stepdata.patrimonio.vende*/
        false
      );
    }
  },

  methods: {
    bad(val) {
      return this.tryAdd && !val;
    },

    addImovel() {
      this.tryAdd = true;

      if (this.missingField) {
        return;
      }
      this.tryAdd = false;

      let n = { ...this.stepdata.patrimonio };

      this.stepdata.patrimonios.push(n);

      this.stepdata.patrimonio = {
        imovel: "",
        utilizacao: "",
        valor: 0,
        vende: ""
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.badinput {
  border: solid 1px #e90054 !important;
}

.sectiontitle {
  display: flex;
  justify-content: center;
  margin-left: 0.75rem;
  margin-right: -0.75rem;
  margin-top: 5rem;
  margin-bottom: 2rem;
}

.column {
  padding: 0;
}

#stepcontent {
  position: relative;
  text-align: center;
}
#title {
  padding: 2rem 0;
}
#title h2 {
  color: #2d3256;
  font-weight: 900;
  font-size: 2.5rem;
}
#title p {
  color: #4f4f4f;
  font-weight: 400;
  font-size: 1.25rem;
}

$input-width: 45rem;

#formblock {
  max-width: $input-width;
  margin: auto;
  margin-bottom: 2rem;
}

#formblock h3 {
  font-size: 2rem;
  white-space: nowrap;
  margin: 0 0.5rem;
}

hr {
  height: 2px;
  width: 100%;
  color: #4a4a4a;
  background: #4a4a4a;
}

$font-size: 1.125rem;
$input-line-height: 3rem;
.input-line {
  border: solid 1px #f5f5f5;
  position: relative;
  background-color: #ffffff;
  height: $input-line-height;
  display: flex;
  margin: 0.75rem;
}

.input-expanded {
  position: absolute;
  background-color: #ffffff;
  width: 100%;
  margin: -0.75rem 0.75rem 0.75rem;
  color: black;
  padding: 0.5rem 1rem 0;
  max-width: $input-width;
  z-index: 4;
  max-height: $input-line-height * 0.8 * 5;
  overflow-y: auto;
}

.expanded-line {
  position: relative;
  height: $input-line-height * 0.8;
  line-height: $input-line-height * 0.8;
  font-size: $font-size * 0.8;
  display: flex;
  padding-left: 0.75rem;
  border-bottom: solid 1px #f1f1f1;
  cursor: pointer;
}

.expanded-line:hover {
  color: white !important;
  background-color: #e90054 !important;
}

.expanded-line:last-child {
  border-bottom: none;
}

.input-title {
  line-height: $input-line-height;
  padding: 0 0 0 1.25rem;
  color: black;
  font-size: $font-size;
  flex-grow: 1;
  white-space: nowrap;
}

.input-line p {
  text-align: left;
}

.input-title {
  line-height: $input-line-height;
  padding: 0 1.25rem;
  color: black;
  font-size: $font-size;
  flex-grow: 1;
  white-space: nowrap;
}

.input-field {
  //line-height:$input-line-height;
  padding: 0.675rem 1rem;
  color: black;
  font-size: $font-size;
  flex-grow: 10;
}

.input-field input {
  //line-height:$input-line-height;
  text-align: right;
  color: #4a4a4a;
  cursor: text;
  width: 100%;
  font-weight: 600;
  outline: none !important;
}

.input-icon {
  line-height: 1rem;
  padding: 1rem 0.5rem;
  color: black;
  width: 2rem;
  min-width: 32px;
}

.input-icon img {
  cursor: pointer;
}

.flip {
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  transform: rotate(180deg);
}

.unflip {
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  transform: rotate(0deg);
}
</style>



// WEBPACK FOOTER //
// src/pages/CreditoHabitacao/Step4.vue